import React from 'react';
import { arrayOf, shape, string } from 'prop-types';
import SectionHead from './SectionHead';

/** "Preise und Vorlaufzeit" — the price range and lead time cards. */
const InfoCards = props => {
  const { heading, text, cards } = props;
  if (!cards.length) {
    return null;
  }
  return (
    <section aria-labelledby="info-title">
      <div className="container">
        <SectionHead id="info-title" heading={heading} text={text} />
        <div className="info-grid">
          {cards.map(card => (
            <div className="info-card" key={card.label}>
              <div className="info-label">{card.label}</div>
              <div className="info-value">{card.value}</div>
              <p>{card.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

InfoCards.propTypes = {
  heading: string,
  text: string,
  cards: arrayOf(shape({ label: string, value: string, text: string })),
};
InfoCards.defaultProps = { cards: [] };

export default InfoCards;
